import styled from 'styled-components'
import {Link as LinkS} from 'react-scroll'
import {FaTimes, FaFacebook, FaInstagram} from 'react-icons/fa'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: #0d0d0d;
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

export const CloseIcon = styled(FaTimes)`
    color: #fff;
`;

export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`;

export const SidebarWrapper = styled.div`
    color: #fff;
`
export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 80px);
    text-align: center;

    @media screen and (max-width: 480px) {
        grid-template-rows: repeat(6, 60px);
    }
`

export const SidebarLink = styled(LinkS)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    color: #fff;
    cursor: pointer;

    &:hover {
        color: #0195FE;
        transition: 0.2s ease-in-out;
    }
`
export const SocialsWrap = styled.div`
    display: flex;
    justify-content: center;
`
export const FBIcon = styled(FaFacebook)`
    color: #fff;
    cursor: pointer;
    margin-right: 15px;
    height: 40px;
    width: 40px;

    &:hover {
        color: #0195FE;
    }
`
export const IGIcon = styled(FaInstagram)`
    color: #fff;
    cursor: pointer;
    height: 40px;
    width: 40px;

    &:hover {
        color: #0195FE;
    }
`
export const BooksyLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top:100px;
`
export const BooksyTxt = styled.p`
  font-size: 20px;
  margin-bottom: 20px;
`
export const BooksyIcon = styled.img`
  width: 60px;
  height: 60px;
  cursor: pointer;
`
